import * as queryString from './query-string';

export default function (videoItem, settings) {
  const { id } = videoItem;
  const { siteUrl, compId } = settings;

  const [host, queryAndHash = ''] = siteUrl.split('?');
  const [query = '', hash = ''] = queryAndHash.split('#');
  const queryParams = queryString.parse(query);
  const videoArgs = {
    ...queryParams,
    'wix-vod-video-id': id,
  };

  if (compId) {
    videoArgs['wix-vod-comp-id'] = compId;
  }

  const videoQueryString = queryString.stringify(videoArgs);

  return `${host}${videoQueryString}#${hash}`;
}



// WEBPACK FOOTER //
// ./src/widget/player-widget/utils/get-url-to-video.js